// Safely extract a server error message from a failed fetch Response.
// If the body isn't valid JSON (e.g. a backend 500 debug page), falls back
// to `fallback` instead of throwing — so callers' outer catch blocks only
// ever see genuine network failures, never a JSON-parse error mislabeled
// as "Network error".
export async function safeErrorMessage(response, fallback) {
  try {
    const data = await response.json();
    return data.error || fallback;
  } catch {
    return fallback;
  }
}
